module.exports = __webpack_public_path__ + "static/media/FOND_INTERFACE.7ca2f34b.jpg";